module.exports = __webpack_public_path__ + "img/cooperate_11.b6c4d52e.png";